<ng-container *ngIf="testimonialData != null && testimonialData != undefined && testimonialData.length">
    <div class="testimonial-section">
        <div class="container">
            <div class="heading">
                <h2>{{'SHARED.ELEMENT.TESTIMONIAL.HEADING' | translate}}</h2>
                <p>{{'SHARED.ELEMENT.TESTIMONIAL.SUB_HEADING' | translate}}</p>
            </div>
            <div class="testimonial_carousel">
                <owl-carousel-o [options]="customOptions">
                    <ng-container *ngFor="let testimonial of testimonialData">
                        <ng-template carouselSlide>
                            <div class="item">
                                <div class="testimonialbox">
                                    <div class="testimonial-para mCustomScrollbar">
                                        <p [innerHtml]="testimonial.description"></p>
                                    </div>
                                    <div class="testimonialinfo">
                                        <figure *ngIf="testimonial.image != null && testimonial.image != undefined && testimonial.image != ''"><img src="{{image_url + testimonial.image}}?dim67x67&type=resize" height="100%" width="100%" alt="user image"></figure>
                                        <figure *ngIf="testimonial.image == null || testimonial.image == undefined || testimonial.image == ''"><img src="{{image_url + testimonial.image}}client-img1.jpg?dim67x67&type=resize" height="100%" width="100%" alt="user image"></figure>
                                        <strong>{{testimonial.name}} <span>{{testimonial.location}}</span></strong>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</ng-container>